<template>
    <div class="maps">
        <div class="search" id="search" ref="search">
            <label for="search-data" class="search-label">Search</label>
            <input type="text" id="search-data" />
            <div class="orderBy">
                <h4>Order by</h4>
                <label>
                    <input type="radio" name="orderBy" value="name" />
                    Name
                </label>
                <label>
                    <input type="radio" name="orderBy" value="author" />
                    Author
                </label>
                <label>
                    <input type="radio" name="orderBy" value="date" checked />
                    Date
                </label>
                <label>
                    <input type="radio" name="orderBy" value="downloads" />
                    Downloads
                </label>
            </div>
        </div>
        <div class="content" id="mapsContent" ref="mapsContent">
            <div
                v-for="map in maps"
                class="map-center"
                :key="map._id"
                :data-date="map.date"
                :data-downloads="map.downloads ? map.downloads : 0"
            >
                <div class="map">
                    <img :src="map.picture" class="image" :alt="map.name" />
                    <div>
                        <div class="top">
                            <div class="info">
                                <div class="title">{{ map.name }}</div>
                                <div class="author">
                                    By
                                    <router-link
                                        :to="{
                                            name: 'home',
                                            query: {
                                                id: map.user.id,
                                                ...(!!$parent.embedded
                                                    ? { embedded: true }
                                                    : {}),
                                            },
                                        }"
                                        tag="a"
                                    >
                                        {{ map.user.name }}</router-link
                                    >
                                </div>
                            </div>
                            <div class="buttons">
                                <select
                                    :id="
                                        `
                                        ${map._id}
                                    -selected-version`
                                    "
                                    :ref="`${map._id}-selected-version`"
                                    class="selected-version"
                                >
                                    <template v-if="map.versions">
                                        <option
                                            v-for="version in map.versions"
                                            :key="version.name"
                                            :selected="
                                                map.currentVersion
                                                    ? version.name ===
                                                      map.currentVersion
                                                    : undefined
                                            "
                                            :value="version.name"
                                            >{{ version.name }}
                                        </option></template
                                    >
                                    <option v-else selected value="default"
                                        >default
                                    </option>
                                </select>
                                <button
                                    v-if="$parent.embedded"
                                    class="download button-blue"
                                    @click="
                                        () => {
                                            chooseFromMeta(map);
                                        }
                                    "
                                >
                                    Choose
                                </button>
                                <button
                                    v-else
                                    class="download button-blue"
                                    @click="
                                        () => {
                                            downloadFromMeta(map);
                                        }
                                    "
                                >
                                    Download
                                </button>
                                <!-- @TODO: when play link add -->
                                <!-- <button class="play button-green">Play</button> -->
                            </div>
                        </div>
                        <div class="description">{{ map.description }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="spinner" v-if="loading">
            <div class="preload_spinner">
                <div class="preload_spinner_inside">
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import variables from "../../api/variables.json";
export default {
    name: "Home",
    data() {
        return {
            loading: true,
            lastSort: { pervious: "date", flip: true },
            loadedMaps: [],
        };
    },
    computed: {
        maps() {
            return this.loadedMaps;
        },
    },
    created() {
        this.getMaps();
    },
    mounted() {
        this.$nextTick(function() {
            if (this.$parent.embedded) {
                const search = this.$refs.search;
                search.classList.add("search-embedded");
            }

            //setup search
            const searchInput = document.getElementById("search-data");
            searchInput.addEventListener("keyup", () => {
                this.calculateMaps(searchInput.value);
            });
            const sortBy = document.getElementsByName("orderBy");
            sortBy.forEach((s) =>
                s.addEventListener("click", () => {
                    this.sortMaps();
                })
            );
        });
    },
    methods: {
        getMap(id) {
            let url = `${variables.host}/api/map?id=${id}`;

            return fetch(url)
                .then((response) => response.json())
                .then((maps) => {
                    return maps[0];
                })
                .catch((err) => {
                    console.log(err);
                    return err;
                });
        },
        getMapsPage(page, size, id = null) {
            let url = `${variables.host}/api/maps/meta?size=${size}&page=${page}`;
            if (id !== null) {
                url += "&user=" + id;
            }

            return fetch(url)
                .then((response) => response.json())
                .then((maps) => {
                    this.loadedMaps = [...maps, ...this.loadedMaps];
                    maps.forEach((currentMap) => {
                        console.log("Loading image: ", currentMap._id);
                        let pictureUrl = `${variables.host}/api/image/${currentMap._id}`;
                        fetch(pictureUrl)
                            .then((response) => {
                                return response.blob();
                            })
                            .then((image) => {
                                const urlImage = URL.createObjectURL(image);
                                const map = this.loadedMaps.find(
                                    (map) => map._id === currentMap._id
                                );
                                map.picture = urlImage;
                                this.$set(
                                    this.loadedMaps,
                                    this.loadedMaps.indexOf(map),
                                    map
                                );
                                console.log("Image loaded: ", currentMap._id);
                            });
                    });
                    return maps;
                })
                .catch((err) => {
                    console.log(err);
                    return err;
                });
        },
        getMapsPages(promise, page, size, id) {
            return promise
                .then(() => this.getMapsPage(page, size, id))
                .then((maps) => {
                    this.$nextTick(function() {
                        const selects = Object.keys(this.$refs)
                            .filter((x) => x.includes("-selected-version"))
                            .map((x) => this.$refs[x][0]);
                        selects.forEach((select) => {
                            if (select && select.childElementCount < 2) {
                                if (select) {
                                    return (select.style.display = "none");
                                } else {
                                    return "";
                                }
                            } else if (select) {
                                return (select.style.display = null);
                            } else {
                                return "";
                            }
                        });
                        this.sortMaps(false);
                    });
                    if (maps.length < 1) return;
                    return this.getMapsPages(promise, page + 1, size, id);
                });
        },
        getMaps() {
            const userMaps = new URL(window.location.href);
            let id = null;

            // Add back button if maps by specific user
            if (userMaps.searchParams.has("id")) {
                id = userMaps.searchParams.get("id");
                this.$parent.backSearch = "id";
            }

            // Reset maps
            this.loadedMaps = [];
            this.getMapsPages(Promise.resolve(), 0, 2, id).then(() => {
                this.sortMaps(false);
                this.loading = false;
            });
        },
        chooseFromMeta(mapMeta) {
            if (
                mapMeta.map ||
                (mapMeta.versions &&
                    mapMeta.versions[0] &&
                    mapMeta.versions[0].map)
            ) {
                this.choose(mapMeta);
            } else {
                this.getMap(mapMeta._id).then((map) => {
                    mapMeta = map;
                    this.choose(mapMeta);
                });
            }
        },
        choose(map) {
            const select = this.$refs[`${map._id}-selected-version`][0];
            parent.postMessage(
                {
                    type: "set-map",
                    map: map.versions
                        ? map.versions.find((map) => map.name === select.value)
                            ? map.versions.find(
                                  (map) => map.name === select.value
                              ).map
                            : map.map
                        : map.map,
                },
                "*"
            );
            fetch(`${variables.host}/api/download`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: map._id,
                }),
            });
        },
        downloadFromMeta(mapMeta) {
            if (
                mapMeta.map ||
                (mapMeta.versions &&
                    mapMeta.versions[0] &&
                    mapMeta.versions[0].map)
            ) {
                this.download(mapMeta);
            } else {
                this.getMap(mapMeta._id).then((map) => {
                    mapMeta = map;
                    this.download(mapMeta);
                });
            }
        },
        download(map) {
            const select = this.$refs[`${map._id}-selected-version`][0];
            const name =
                `${map.name}-` + select.options[select.selectedIndex].text;
            console.log(map.versions, select.value);

            var dataStr =
                "data:text/json;charset=utf-8," +
                encodeURIComponent(
                    JSON.stringify(
                        map.versions
                            ? map.versions.find(
                                  (map) => map.name === select.value
                              )
                                ? map.versions.find(
                                      (map) => map.name === select.value
                                  ).map
                                : map.map
                            : map.map
                    )
                );
            var dlAnchorElem = document.createElement("a");
            dlAnchorElem.setAttribute("href", dataStr);
            dlAnchorElem.setAttribute("download", name + ".json");
            dlAnchorElem.click();
            dlAnchorElem.remove();

            fetch(`${variables.host}/api/download`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: map._id,
                }),
            });
        },

        sortMaps(allowFlip = true) {
            const sortBy = document.querySelector(
                'input[name="orderBy"]:checked'
            ).value;

            const p = document.getElementById("mapsContent");
            const itemsToSort = p.getElementsByClassName("map-center");
            // get all data into a sortable array
            var data = [],
                order = [],
                item,
                placeHolder,
                i;
            for (i = 0; i < itemsToSort.length; i++) {
                item = itemsToSort[i];
                // save position of item by inserting a placeholder right before it
                placeHolder = document.createElement(item.tagName);
                item.parentNode.insertBefore(placeHolder, item);
                order.push(placeHolder);

                const name = item.querySelector(".title").innerText;
                const description = item.querySelector(".description")
                    .innerText;
                const author = item.querySelector(".author").querySelector("a")
                    .innerText;
                const date = new Date(item.getAttribute("data-date"));
                const downloads = Number.parseInt(
                    item.getAttribute("data-downloads")
                );
                // save item and text
                data.push({
                    obj: item,
                    name,
                    description,
                    author,
                    date,
                    downloads,
                });
            }

            // sort the item array by the text
            data.sort((a, b) => {
                if (sortBy === "date" || sortBy === "downloads") {
                    return b[sortBy] - a[sortBy];
                } else if (typeof a[sortBy] === "string") {
                    return a[sortBy].localeCompare(b[sortBy]);
                } else {
                    return 0;
                }
            });

            if (this.lastSort.pervious === sortBy && allowFlip) {
                if (this.lastSort.flip) {
                    data.reverse();
                }
                this.lastSort.flip = !this.lastSort.flip;
            } else {
                this.lastSort.flip = true;
            }
            this.lastSort.pervious = sortBy;

            // now reinsert items in sorted order
            for (i = 0; i < data.length; i++) {
                item = data[i].obj;
                placeHolder = order[i];
                // insert in new location
                placeHolder.parentNode.insertBefore(item, placeHolder);
                // remove placeholder
                placeHolder.parentNode.removeChild(placeHolder);
            }
        },

        calculateMaps(searchQuery) {
            searchQuery = searchQuery.toLowerCase().trim();
            let maps = Array.from(document.querySelectorAll(".map-center"));
            if (searchQuery === "")
                return maps.forEach((m) => (m.style.display = null));

            maps = maps.map((m) => {
                const element = m;
                const name = m.querySelector(".title").innerText.toLowerCase();
                const description = m
                    .querySelector(".description")
                    .innerText.toLowerCase();
                const authorName = m
                    .querySelector(".author")
                    .querySelector("a")
                    .innerText.toLowerCase();

                return {
                    element,
                    name,
                    description,
                    authorName,
                };
            });

            maps.forEach((m) => {
                if (
                    m.name.includes(searchQuery) ||
                    m.description.includes(searchQuery) ||
                    m.authorName.includes(searchQuery)
                )
                    m.element.style.display = null;
                else m.element.style.display = "none";
            });

            this.sortMaps();
        },
    },
    watch: {
        "$route.query.id": function() {
            this.getMaps();
        },
    },
};
</script>

<style scoped lang="scss" src="./assets/css/maps.scss"></style>
